import { FormattedHTMLMessage } from '@99designs/common/i18n';
import ColorComponent from 'projects/components/Color';
import { Color } from 'projects/consts';
import React from 'react';

const SquareAuthModal = {
    signupHeading: __('Create a 99designs account to see your matches!'),
    signupMessage: (
        <div className="auth-description">
            <ColorComponent color={Color.puntRoad}>
                <div className="paragraph paragraph--small">
                    <FormattedHTMLMessage
                        message={__(
                            "Now that you've completed your brief you're just a click away from connecting with certified <strong>Square Online Store</strong> experts."
                        )}
                    />
                </div>
                <div className="paragraph paragraph--small">
                    <FormattedHTMLMessage
                        message={__(
                            "Once you've created your 99designs account, you'll be able to review <strong>Square Online Store</strong> experts and start receiving quotes in just 24 hours."
                        )}
                    />
                </div>
            </ColorComponent>
        </div>
    ),
};

export default SquareAuthModal;
